<script>
    /**
     * @typedef {Object} Props
     * @property {any} label
     * @property {string} [position] - 'inline' or 'relative'
     * @property {string} [icon]
     * @property {Function} [onclick] - External event handler
     */
    let { label, position = 'absolute', icon = 'add', onclick } = $props();
</script>

<button
    class="add-button {position} interactive"
    {onclick}
    title={label}
>
    <i class="material-icons" aria-hidden="true">{icon}</i>
    <span>{label?.trim()}</span>
</button>

<style>
    .add-button {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-items: flex-start;
        padding: 0.75rem 1rem;
        border-radius: 1rem;
        background-color: #111;
        color: #ddd;
        flex-grow: 0;
        z-index: 1000;
    }

    .add-button span {
        text-transform: uppercase;
        font-size: 0.9rem;
        font-weight: 600;
        margin-left: 0.5rem;
    }

    .add-button i {
        margin: 0;
        padding: 0;
    }

    .add-button:hover {
        box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.25);
        color: white;
    }

    .add-button.absolute {
        position: absolute;
        top: -3.25rem;
        right: 4rem;
    }

    .add-button.inline {
        position: absolute;
    }

    .add-button.relative {
        position: relative;
    }

    @media (max-width: 960px) {
        .add-button span {
            display: none;
        }
        .add-button {
            padding: 0.75rem;
        }
        .add-button.relative {
            right: 0;
        }
    }
</style>
